import React from 'react';
import { observer } from 'mobx-react';
import { CapacityPlannerScreen } from '../../screen/CapacityPlanner/Screen';

interface Props { planner: CapacityPlannerScreen; }

@observer
export class Header extends React.Component<Props> {
    render() {
        const p = this.props.planner;
        return (
            <header className="header" data-test-cp-header>
                <h1>Capacity Planner</h1>
                <div className="header-actions">
                    <button className="btn btn-primary" data-test-cp-time-tracking-btn onClick={p.openTimeTracking}>Time Tracking</button>
                    <button className="btn btn-secondary" data-test-cp-new-project-btn onClick={p.addProject}>+ New Project</button>
                    <button className="btn btn-secondary" data-test-cp-add-developer-btn onClick={() => {
                        if (p.users.length > 0) p.openDeveloperModal(p.users[0].id as any);
                    }}>+ Add Developer</button>
                </div>
            </header>
        );
    }
}
